import React from 'react';
import { NavLink } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

import Tooltip from '@app/src/common/components/tooltip/Tooltip';
import useTranslate from '@app/src/common/hooks/useTranslation';

import { IModuleEntry } from './moduleEntries';

export interface IProps {
  entry: IModuleEntry;
  className?: string;
  location?: any;
  collapsed?: boolean;
}

const NavigationItem = ({ location, entry, className, collapsed }: IProps) => {
  const translate = useTranslate();
  const { path, labelId, Icon } = entry;
  const isActive = () =>
    !!location && !!path && location.pathname.startsWith(path);
  const tooltipId = `nav-tooltip-${entry.key}`;
  const tooltipLabel = collapsed ? translate(labelId) : '';

  const content = (
    <div className="navigation__link-inner">
      <span className="navigation__link-icon">
        <Icon />
      </span>
      <FormattedMessage id={labelId}>
        {(...message) => (
          <span className="navigation__link-title">{message}</span>
        )}
      </FormattedMessage>
    </div>
  );

  return (
    <>
      {path ? (
        <NavLink
          to={path}
          className={className}
          activeClassName="navigation__link_active"
          isActive={isActive}
          data-tooltip-id={collapsed ? tooltipId : undefined}
        >
          {content}
        </NavLink>
      ) : (
        // External module: leaves the platform app, so it never carries the active state.
        <button
          type="button"
          className={className}
          onClick={entry.navigate}
          data-tooltip-id={collapsed ? tooltipId : undefined}
        >
          {content}
        </button>
      )}
      {collapsed && (
        <Tooltip id={tooltipId} place="right" className="navigation__tooltip">
          {tooltipLabel}
        </Tooltip>
      )}
    </>
  );
};

export default NavigationItem;
